export default function isUsingStrings(text) {
  return typeof text === 'number';
}
